import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import Flex from '@magalu/stereo-ui/atoms/Flex';
import { themeGet } from '@magalu/stereo-ui-styles';
export var TotalLabel = styled(Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-top: 16px;\n"])), themeGet('colors.darkSilver'));